import script from "./AdminHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AdminHeader.vue?vue&type=style&index=0&id=5cbd8072&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ryuta_ariga\\source\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbd8072"]])

export default __exports__